import { jsx as C, jsxs as s } from "react/jsx-runtime";
const L = () => /* @__PURE__ */ C("svg", { viewBox: "0 0 800 195", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ s("g", { clipPath: "url(#clip0_977_60)", children: [
  /* @__PURE__ */ C(
    "path",
    {
      d: "M800 0H796.248C780.774 0 769.707 8.29795 765.111 23.0291L712.591 194.023H716.155C731.63 194.023 742.79 185.632 747.292 170.9L800 0Z",
      className: "cls-2"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M746.823 0H740.727C725.252 0 714.279 8.29795 709.684 23.0291L657.163 194.023H663.072C678.546 194.023 689.707 185.632 694.209 170.9L746.823 0Z",
      className: "cls-2"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M633.435 0H622.556C607.081 0 595.92 8.29795 591.419 23.0291L538.898 194.023H549.777C565.252 194.023 576.319 185.632 580.821 170.9L633.435 0Z",
      className: "cls-2"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M691.301 0H682.954C667.48 0 656.413 8.29795 651.817 23.0291L599.39 194.023H607.644C623.119 194.023 634.279 185.632 638.781 170.9L691.301 0Z",
      className: "cls-2"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M79.7186 0C60.4924 0 43.517 12.4935 37.8898 30.7677L23.6342 77.1056C17.5381 97.058 32.544 117.29 53.5522 117.29H178.945C179.977 117.29 180.727 118.316 180.445 119.248L171.348 148.71C171.067 149.643 170.223 150.202 169.285 150.202H46.0492C26.6354 150.202 9.56624 162.789 3.93904 181.156L0 193.836H164.127H169.097H175.569C190.95 193.836 204.549 183.86 209.05 169.222L225.275 116.731C231.372 96.7783 216.366 76.5462 195.358 76.5462H69.871C68.8394 76.5462 68.0891 75.5206 68.3705 74.5883L77.4678 45.1259C77.7491 44.1936 78.5932 43.6341 79.5311 43.6341H199.109C218.523 43.6341 235.592 31.0474 241.219 12.68L244.877 0H79.7186Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M315.498 0C296.272 0 279.297 12.4935 273.669 30.7677L238.124 146.193C230.809 169.968 248.722 193.93 273.669 193.93H411.254C426.635 193.93 440.234 183.953 444.736 169.315L446.518 163.442C446.518 163.348 446.612 163.255 446.612 163.162L452.145 145.074L459.179 122.325C459.273 122.045 459.273 121.859 459.367 121.579L460.867 116.824C466.964 96.8715 451.958 76.6395 430.95 76.6395H377.304H330.973C329.379 98.9227 349.637 117.197 372.145 117.197H414.631C415.662 117.197 416.413 118.222 416.131 119.155L407.034 148.617C406.846 149.27 406.284 149.829 405.627 150.016C405.44 150.109 405.158 150.109 404.971 150.109H377.21H282.954C281.923 150.109 281.172 149.083 281.454 148.151L313.154 45.2192C313.435 44.2868 314.279 43.7274 315.217 43.7274H434.982C454.209 43.7274 471.184 31.2338 476.811 12.9597L480.75 0H315.498Z",
      className: "cls-1"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M573.224 0H553.623C534.584 0 517.796 12.4935 512.169 30.5812L461.899 194.023H487.503C502.884 194.023 516.671 183.86 521.172 169.222L573.224 0Z",
      className: "cls-1"
    }
  )
] }) });
export {
  L as SgiLogoSvg
};
